import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';
import { COLORS } from '../constants';
import { GameResult } from '../carRaceEngine';
import PlayButton from './PlayButton';

const Crash = styled.div`
  font-size: 44px;
  line-height: 1;
`;

const ScoreRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
`;

const ScoreBig = styled.span`
  font-size: 54px;
  font-weight: 800;
  color: ${COLORS.yellow};
  line-height: 1;
`;

const ScoreSub = styled.span`
  font-size: 13px;
  color: #888;
`;

const NewRecordBadge = styled.span`
  background: ${COLORS.yellow};
  color: ${COLORS.black};
  font-size: 11px;
  font-weight: 800;
  border-radius: 20px;
  padding: 3px 10px;
  letter-spacing: 0.5px;
`;

const Message = styled.p`
  font-size: 14px;
  color: #bbb;
  text-align: center;
  max-width: 300px;
  line-height: 1.6;
`;

const Best = styled.div`
  font-size: 13px;
  color: #666;

  span {
    color: ${COLORS.yellow};
    font-weight: 700;
  }
`;

export interface GameOverOverlayProps {
  result: GameResult;
  onRestart: () => void;
}

const GameOverOverlay = ({ result, onRestart }: GameOverOverlayProps) => {
  const { t } = useTranslation();

  const messages = [
    t('Not bad! Try collecting even more stars next time.'),
    t("Sweden's best used-car marketplace is waiting for you!"),
    t('Play again and beat your record!')
  ];
  // Pick once per game-over (keyed by the score so a new run re-rolls).
  const message = useMemo(
    () => messages[Math.floor(Math.random() * messages.length)],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [result.score]
  );

  return (
    <>
      <Crash>💥</Crash>
      <ScoreRow>
        <ScoreBig>{result.score}</ScoreBig>
        <ScoreSub>{t('points')}</ScoreSub>
        {result.isNewRecord && (
          <NewRecordBadge>🏆 {t('NEW RECORD!')}</NewRecordBadge>
        )}
      </ScoreRow>
      <Message>{message}</Message>
      <PlayButton type="button" onClick={onRestart}>
        {t('Play again')}
      </PlayButton>
      <Best>
        {t('Record')}: <span>{result.best}</span>
      </Best>
    </>
  );
};

export default GameOverOverlay;
